/*
 * Peças de Reposição — motor compartilhado pelas versões pecas-v1..v10.
 * Carrega os produtos da coleção (products.json), classifica cada peça
 * (equipamento, categoria, marca, modelos compatíveis), filtra, busca,
 * ordena, sincroniza o estado com a URL e adiciona ao minicart do tema.
 *
 * Uso:  PecasEngine.load().then(({ items, facets }) => ...)
 */
(function () {
  if (window.PecasEngine) return;

  var WA_PHONE = '554396734319';

  /* ---------- Taxonomia ---------- */
  var EQUIPS = [
    { key: 'rodas', label: 'Cadeira de rodas', short: 'Cadeira de rodas', icon: 'wheelchair' },
    { key: 'motorizada', label: 'Motorizada e scooter', short: 'Motorizada', icon: 'motor',
      re: /motorizad|scooter|scott|power ?lite|joystick|bateria|carregador|\bd ?(800|900|1000|3000)\b|\bpop\b|trava de bateria|caixa-case/ },
    { key: 'banho', label: 'Cadeira de banho', short: 'Cadeira de banho', icon: 'bath',
      re: /banho|higienica|hygienika|\bd ?(30|40|45|50|60|65)\b|\bb20\b|\bdx\d\b/ },
    { key: 'andador', label: 'Andador', short: 'Andador', icon: 'walker', re: /andador/ },
    { key: 'guincho', label: 'Guincho de transferência', short: 'Guincho', icon: 'lift', re: /guincho/ },
    { key: 'inalador', label: 'Inalador e nebulizador', short: 'Inalador', icon: 'inhaler', re: /inalador|nebuliz/ },
    { key: 'cpap', label: 'CPAP', short: 'CPAP', icon: 'cpap', re: /cpap|airfit|amara/ },
    { key: 'carrinho', label: 'Carrinho postural', short: 'Carrinho', icon: 'stroller', re: /carrinho/ },
    { key: 'cama', label: 'Cama hospitalar', short: 'Cama hospitalar', icon: 'bed', re: /cama hospitalar|cama fawler/ }
  ];
  // ordem de teste (o primeiro que casar vence); 'rodas' é o padrão
  var EQUIP_TEST = ['cama', 'motorizada', 'banho', 'andador', 'guincho', 'inalador', 'cpap', 'carrinho'];

  var CATS = [
    { key: 'rodas', label: 'Rodas e rodízios', icon: 'wheel' },
    { key: 'pneus', label: 'Pneus e câmaras', icon: 'tire' },
    { key: 'freios', label: 'Freios', icon: 'brake' },
    { key: 'apoios', label: 'Apoios de pé e perna', icon: 'foot' },
    { key: 'estofados', label: 'Estofados e assentos', icon: 'seat' },
    { key: 'baterias', label: 'Baterias e carregadores', icon: 'battery' },
    { key: 'controle', label: 'Joystick e controle', icon: 'joystick' },
    { key: 'estrutura', label: 'Garfos e estrutura', icon: 'wrench' },
    { key: 'acessorios', label: 'Acessórios e kits', icon: 'kit' },
    { key: 'outros', label: 'Outras peças', icon: 'box' }
  ];

  // 1º) substantivo do início do título; 2º) termos no restante (sem "cadeira de rodas", que aparece em quase tudo)
  var CAT_START = [
    ['rodas', /^(roda|rodizio|rodinha|anti-?tombo)/], ['pneus', /^(pneu|par de pneu|camara)/],
    ['freios', /^(freio|par de freio|mola de freio|borracha da alavanca|suporte de freio)/], ['apoios', /^(apoio|pedal)/],
    ['estofados', /^(estofa|almofada|assento|encosto)/],
    ['baterias', /^(bateria|kit \d+ baterias|carregador|adaptador de carregador|caixa-case|trava de bateria)/],
    ['controle', /^(joystick|controlador)/], ['estrutura', /^(garfo|conjunto de garfo|kit de parafusos|pe de cadeira|kit montagem|cesto|eixo)/],
    ['acessorios', /^(kit de acess|mascara|filtro|mangueira)/]
  ];
  function classifyCat(t) {
    var t0 = t.replace(/^\([^)]*\)\s*/, '');
    for (var i = 0; i < CAT_START.length; i++) if (CAT_START[i][1].test(t0)) return CAT_START[i][0];
    t = t.replace(/cadeiras? de rodas?/g, '');
    if (/^pneu|camara de ar/.test(t)) return 'pneus';
    if (/bateria|carregador|caixa-case|adaptador de carregador/.test(t)) return 'baterias';
    if (/joystick|controlador/.test(t)) return 'controle';
    if (/\broda|rodizio|rodinha/.test(t)) return 'rodas';
    if (/freio/.test(t)) return 'freios';
    if (/apoio|pedal|panturrilha/.test(t)) return 'apoios';
    if (/estofa|almofada|assento|encosto/.test(t)) return 'estofados';
    if (/garfo|parafuso|estrutura|chassi|eixo|kit montagem|cesto/.test(t)) return 'estrutura';
    if (/kit de acess|mascara|filtro|mangueira|traqueia|copo/.test(t)) return 'acessorios';
    return 'outros';
  }

  var BRANDS = ['Dellamed', 'Ottobock', 'Prolife', 'Ortobras', 'CDS', 'Power Lite', 'Hidrolight', 'Supermedy',
    'Ortomobil', 'Incoterm', 'ResMed', 'BMC', 'Zeus', 'EcoPower', 'Vanzetti', 'Jaguaribe', 'Freedom', 'Mercur'];

  // grafias diferentes do mesmo modelo nos títulos (chave normalizada → nome oficial)
  var MODEL_ALIAS = { scooters: 'Scott S' };

  var MODEL_RES = [
    /\bD ?\d{2,4}\b/gi, /\bDX\d\b/gi, /\bPL ?0*\d{1,3}\b/gi, /\bM\d{1,4}\b/g, /\bH\d{1,2}\b/g, /\bB20\b/gi,
    /\bScott ?(XL|X|S)\b/gi, /\bScooter S\b/gi, /\bNB ?\d{3}\b/gi,
    // (máscaras de CPAP como "Airfit F20"/"Amara View" são o próprio produto, não modelo de equipamento)
    /\b(Kimba|Tetra|Elite|Ventura|Solmini|Hygienika|Flex Plus|Pr[aá]tica)\b/gi, /\bPOP\b/g, /\bLB\b/g
  ];

  /* ---------- Utilidades ---------- */
  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function toCents(v) { return Math.round(parseFloat(v || 0) * 100); }
  function money(cents) {
    return 'R$ ' + (cents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  // mesma regra do snippets/price.liquid
  function priceInfo(cents, compare) {
    var pix = Math.round(cents * 0.9);
    var n = Math.min(Math.floor(cents / 3000), 12);
    if (cents <= 9999) n = 1; else if (n < 2) n = 2;
    return {
      price: cents, compare: compare > cents ? compare : 0, pix: pix, n: n, inst: Math.round(cents / n),
      off: compare > cents ? Math.round((1 - cents / compare) * 100) : 0
    };
  }
  function img(src, w) {
    if (!src) return '';
    src = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 480);
  }
  function modelKey(m) { return norm(m).replace(/[^a-z0-9]/g, ''); }
  function prettyModel(m) {
    var s = m.replace(/\s+/g, ' ').trim();
    if (/^d ?\d/i.test(s) || /^dx|^pl|^nb|^b20|^m\d|^h\d/i.test(s)) return s.toUpperCase().replace(/^(D|PL|NB) ?/, '$1');
    if (/^(pop|lb)$/i.test(s)) return s.toUpperCase();
    return s.toLowerCase().replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); })
      .replace(/\b(Xl|X|S)$/, function (c) { return c.toUpperCase(); }).replace(/F(\d)/i, 'F$1');
  }

  /* ---------- Normalização de um produto ---------- */
  function normalize(p, i) {
    var t = norm(p.title);
    var equip = 'rodas';
    for (var k = 0; k < EQUIP_TEST.length; k++) {
      var e = EQUIPS.filter(function (x) { return x.key === EQUIP_TEST[k]; })[0];
      if (e.re.test(t)) { equip = e.key; break; }
    }
    var brand = '';
    for (var b = 0; b < BRANDS.length; b++) {
      if (t.indexOf(norm(BRANDS[b])) > -1) { brand = BRANDS[b]; break; }
    }
    if (!brand && p.vendor && !/casa m/i.test(p.vendor)) brand = p.vendor;

    var models = [], seen = {};
    MODEL_RES.forEach(function (re) {
      (p.title.match(re) || []).forEach(function (m) {
        var key = modelKey(m);
        if (MODEL_ALIAS[key]) { m = MODEL_ALIAS[key]; key = modelKey(m); }
        if (!seen[key] && !/^(d|m|h)\d{5,}$/.test(key)) { seen[key] = 1; models.push(prettyModel(m)); }
      });
    });
    // modelos que aparecem só no início do handle (ex.: "m1-quick-...", "pl001-pl002-roda-...", "d30-d40-roda-...")
    var hs = String(p.handle || '').split('-');
    for (var hi = 0; hi < hs.length && hi < 4; hi++) {
      var tok = hs[hi];
      if (!/^(d\d{2,4}|dx\d|pl\d{3}|m\d|h\d|b20)$/.test(tok)) break;
      if (!seen[tok]) { seen[tok] = 1; models.push(prettyModel(tok)); }
    }
    var universal = /universal/.test(t) || /^universal-/.test(p.handle);

    var vars = (p.variants || []).map(function (v) {
      return {
        id: v.id, title: v.title, available: v.available !== false,
        price: toCents(v.price), compare: toCents(v.compare_at_price)
      };
    });
    var first = vars.filter(function (v) { return v.available; })[0] || vars[0] || { price: 0, compare: 0 };
    var images = (p.images || []).map(function (im) { return im.src; });

    return {
      i: i, id: p.id, handle: p.handle, title: p.title, url: '/products/' + p.handle,
      vendor: p.vendor, brand: brand, brandKey: modelKey(brand),
      equip: equip, cat: classifyCat(t),
      models: models, modelKeys: models.map(modelKey), universal: universal,
      side: /direito/.test(t) ? 'Direito' : /esquerdo/.test(t) ? 'Esquerdo' : '',
      pack: /\bpar\b/.test(t) ? 'Par' : /unitari|unidade|\bund\b/.test(t) ? 'Unidade' : '',
      image: images[0] || '', image2: images[1] || '',
      variants: vars, variant: first, multi: vars.length > 1,
      available: vars.some(function (v) { return v.available; }),
      p: priceInfo(first.price, first.compare),
      tags: p.tags || [],
      hay: norm([p.title, brand, p.vendor, models.join(' '), (p.tags || []).join(' ')].join(' '))
    };
  }

  /* ---------- Carregamento ---------- */
  // Prévia em /collections/all: separa só as peças do catálogo inteiro.
  // testado contra o INÍCIO do título (sem prefixo "(B20) "), pois "rodas" aparece em quase todo título
  var PREVIEW_INCLUDE = /^(roda|rodizio|rodinha|pneu|freio|par de freio|par de pneu|apoio de pe|apoio de panturrilha|estofamento|bateria|kit \d+ baterias|carregador|adaptador de carregador|joystick|controlador|garfo|conjunto de garfo|caixa-case|trava de bateria|kit de parafusos|kit de acessorios inalador|mola de freio|borracha da alavanca|suporte de freio|mascara facial airfit|mascara cpap|anti-?tombo|encosto (cadeira|de cadeira|para cadeira)|assento (t\d+|de cadeira de rodas|para cadeira de rodas)|pe de cadeira|kit montagem|cesto p\/? ?guincho|eixo)/;
  var PREVIEW_EXCLUDE = /roda de exercicios|^cadeira de|^scooter motorizada|tipoia|bota|faixa|talas|cunhas|kit academico|umidificador|colchao|descartavel/;

  var cache = null;
  function cfg() {
    var el = document.querySelector('script[data-pecas-config]');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  }
  // JSON enxuto via templates/collection.pecas-data.liquid (250/página, sem descrição)
  var fetched = {};
  function fetchCollection(handle) {
    if (fetched[handle]) return fetched[handle];
    function page(n) {
      return fetch('/collections/' + handle + '?view=pecas-data&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); });
    }
    // 1ª página diz o total; as demais vêm em paralelo
    fetched[handle] = page(1).then(function (d) {
      var rest = [];
      for (var n = 2; n <= Math.min(d.pages || 1, 12); n++) rest.push(page(n));
      return Promise.all(rest).then(function (ds) {
        return [d].concat(ds).reduce(function (out, x) { return out.concat(x.products || []); }, []);
      });
    });
    return fetched[handle];
  }

  /* ---------- Modelos (filtro principal): cada modelo ligado ao produto-equipamento da loja ---------- */
  var PARENT_RE = /^(cadeira|scooter|andador|guincho|inalador|nebulizador|carrinho|cpap|aparelho|cama|poltrona)/;
  function parentEquip(t) {
    if (/motorizad|scooter|eletrica/.test(t)) return 'motorizada';
    if (/^cama/.test(t)) return 'cama';
    if (/banho|higienica/.test(t)) return 'banho';
    if (/^andador/.test(t)) return 'andador';
    if (/^guincho/.test(t)) return 'guincho';
    if (/^(inalador|nebulizador)/.test(t)) return 'inalador';
    if (/^carrinho/.test(t)) return 'carrinho';
    if (/cpap/.test(t)) return 'cpap';
    return 'rodas';
  }
  // casa o modelo no título tolerando espaço/hífen entre os caracteres: "scotts" ↔ "Scott S", "d400" ↔ "D 400", "pl001" ↔ "Pl 001"
  function modelRe(key) {
    return new RegExp('(^|[^a-z0-9])' + key.split('').join('[\\s-]?') + '($|[^a-z0-9])');
  }
  function buildModels(items, catalog) {
    var parents = catalog.filter(function (p) {
      var t = norm(p.title);
      return PARENT_RE.test(t) && !/outlet/.test(t);
    });
    var map = {};
    items.forEach(function (it) {
      it.modelKeys.forEach(function (k, i) {
        var m = map[k] || (map[k] = { key: k, label: it.models[i], brands: {}, equips: {}, parts: [], fallback: '' });
        m.parts.push(it);
        if (it.brand) m.brands[it.brand] = (m.brands[it.brand] || 0) + 1;
        m.equips[it.equip] = (m.equips[it.equip] || 0) + 1;
        if (!m.fallback && it.image) m.fallback = it.image;
      });
    });
    var list = Object.keys(map).map(function (k) {
      var m = map[k], re = modelRe(k);
      var brand = Object.keys(m.brands).sort(function (a, b) { return m.brands[b] - m.brands[a]; })[0] || '';
      var cands = parents.filter(function (p) { return re.test(norm(p.title)); });
      // mesma marca primeiro, depois o título mais curto (o modelo "base")
      cands.sort(function (a, b) {
        var ba = brand && norm(a.title + ' ' + a.vendor).indexOf(norm(brand)) > -1 ? 0 : 1;
        var bb = brand && norm(b.title + ' ' + b.vendor).indexOf(norm(brand)) > -1 ? 0 : 1;
        return (ba - bb) || (a.title.length - b.title.length);
      });
      var par = cands[0];
      var equip = par ? parentEquip(norm(par.title))
        : Object.keys(m.equips).sort(function (a, b) { return m.equips[b] - m.equips[a]; })[0];
      var img = par && par.images && par.images[0] ? par.images[0].src : '';
      return {
        key: k, label: m.label, brand: brand, equip: equip,
        name: (EQUIPS.filter(function (e) { return e.key === equip; })[0] || {}).short + ' ' + m.label,
        title: par ? par.title : '', url: par ? '/products/' + par.handle : '',
        // sem produto-equipamento no catálogo → sem foto (as versões mostram o ícone do equipamento).
        // Não usamos a foto de uma peça: ex. bateria no lugar da scooter Scott S engana o cliente.
        image: img, partImage: m.fallback, hasParent: !!par, count: m.parts.length
      };
    });
    // peça ligada a um modelo herda o equipamento do produto-pai (ex.: rodízio DX2 → cama hospitalar)
    var byKey = {};
    list.forEach(function (m) { byKey[m.key] = m; });
    items.forEach(function (it) {
      var eqs = it.modelKeys.map(function (k) { return byKey[k] && byKey[k].hasParent ? byKey[k].equip : ''; }).filter(Boolean);
      if (eqs.length && eqs.every(function (e) { return e === eqs[0]; })) it.equip = eqs[0];
    });
    list.forEach(function (m) {
      m.universalCount = items.filter(function (it) { return it.universal && it.equip === m.equip && it.modelKeys.indexOf(m.key) < 0; }).length;
      m.total = m.count + m.universalCount;
    });
    return list.sort(function (a, b) { return (b.hasParent - a.hasParent) || (b.count - a.count) || a.label.localeCompare(b.label, 'pt', { numeric: true }); });
  }

  var MODELS = {};
  function load() {
    if (cache) return cache;
    var c = cfg();
    var handle = c.source || c.collection || 'all';
    var preview = handle === 'all';
    var parentsHandle = c.parents || 'all';
    cache = Promise.all([fetchCollection(handle), fetchCollection(parentsHandle)]).then(function (res) {
      var out = res[0];
      if (preview) {
        out = out.filter(function (p) {
          var t = norm(p.title).replace(/^\([^)]*\)\s*/, '');
          return PREVIEW_INCLUDE.test(t) && !PREVIEW_EXCLUDE.test(t);
        });
      }
      var items = out.map(normalize);
      var models = buildModels(items, res[1]);
      models.forEach(function (m) { MODELS[m.key] = m; });
      return { items: items, models: models, facets: facets(items), handle: handle };
    });
    return cache;
  }
  function model(key) { return MODELS[modelKey(key || '')] || null; }
  // Peças de um modelo: específicas + universais do mesmo equipamento, agrupadas por categoria
  function partsFor(items, key) {
    var m = model(key); if (!m) return { model: null, specific: [], universal: [], groups: [] };
    var specific = items.filter(function (it) { return it.modelKeys.indexOf(m.key) > -1; });
    var universal = items.filter(function (it) { return it.universal && it.equip === m.equip && it.modelKeys.indexOf(m.key) < 0; });
    var groups = CATS.map(function (c) {
      return { key: c.key, label: c.label, icon: c.icon, items: specific.filter(function (it) { return it.cat === c.key; }) };
    }).filter(function (g) { return g.items.length; });
    return { model: m, specific: specific, universal: universal, groups: groups };
  }

  /* ---------- Facetas ---------- */
  function count(items, fn) {
    var m = {};
    items.forEach(function (it) { [].concat(fn(it)).forEach(function (k) { if (k) m[k] = (m[k] || 0) + 1; }); });
    return m;
  }
  function facets(items, st) {
    // contagens respeitam os OUTROS filtros ativos (facetas cruzadas)
    st = st || {};
    function without(key) { var s = Object.assign({}, st); delete s[key]; return filter(items, s); }
    var eqC = count(without('equip'), function (it) { return it.equip; });
    var catC = count(without('cat'), function (it) { return it.cat; });
    var brC = count(without('marca'), function (it) { return it.brand; });
    var mdItems = without('modelo');
    var mdC = {}, mdLabel = {};
    mdItems.forEach(function (it) {
      it.models.forEach(function (m, idx) {
        var k = it.modelKeys[idx]; mdC[k] = (mdC[k] || 0) + 1; mdLabel[k] = m;
      });
    });
    return {
      equips: EQUIPS.filter(function (e) { return eqC[e.key]; }).map(function (e) { return Object.assign({ count: eqC[e.key] }, e); }),
      cats: CATS.filter(function (c) { return catC[c.key]; }).map(function (c) { return Object.assign({ count: catC[c.key] }, c); }),
      brands: Object.keys(brC).sort().map(function (b) { return { key: modelKey(b), label: b, count: brC[b] }; }),
      models: Object.keys(mdC).sort(function (a, b) { return mdLabel[a].localeCompare(mdLabel[b], 'pt', { numeric: true }); })
        .map(function (k) {
          var m = MODELS[k] || {};
          return { key: k, label: mdLabel[k], count: mdC[k], total: m.total || mdC[k], brand: m.brand, equip: m.equip, name: m.name, image: m.image, title: m.title };
        })
    };
  }

  /* ---------- Filtro, busca e ordenação ---------- */
  var SYN = { rodinha: 'roda', rodizios: 'rodizio', pes: 'pe', pezinho: 'apoio', cadeirante: 'cadeira',
    baterias: 'bateria', pneus: 'pneu', freios: 'freio', rodas: 'roda', controle: 'joystick' };
  function tokens(q) {
    return norm(q).split(/[^a-z0-9]+/).filter(Boolean).map(function (w) { return SYN[w] || w; });
  }
  function filter(items, st) {
    st = st || {};
    var toks = st.q ? tokens(st.q) : [];
    var mk = st.modelo ? modelKey(st.modelo) : '';
    return items.filter(function (it) {
      if (st.equip && it.equip !== st.equip) return false;
      if (st.cat && it.cat !== st.cat) return false;
      if (st.marca && it.brandKey !== modelKey(st.marca)) return false;
      if (mk && it.modelKeys.indexOf(mk) < 0) {
        // universais entram se forem do mesmo equipamento do modelo
        var mm = MODELS[mk];
        if (!(st.universal !== false && it.universal && (!mm || mm.equip === it.equip))) return false;
      }
      if (st.disponivel && !it.available) return false;
      for (var i = 0; i < toks.length; i++) {
        var tk = toks[i];
        var hit = it.hay.indexOf(tk) > -1 || it.modelKeys.some(function (m) { return m === tk || m.indexOf(tk) === 0; });
        if (!hit) return false;
      }
      return true;
    });
  }
  function sort(items, by, q) {
    var a = items.slice();
    if (!by && q) {
      // relevância: título que começa com o termo > categoria do termo > resto
      var toks = tokens(q);
      var score = function (it) {
        var t = norm(it.title).replace(/^\([^)]*\)\s*/, ''), cl = norm(catLabel(it.cat)), s = 0;
        toks.forEach(function (tk) {
          if (t.indexOf(tk) === 0) s += 3;
          if (cl.indexOf(tk) > -1) s += 2;
          if (it.modelKeys.indexOf(tk) > -1) s += 2;
        });
        return s;
      };
      a.forEach(function (it) { it._s = score(it); });
      return a.sort(function (x, y) { return (y._s - x._s) || (y.available - x.available) || (x.i - y.i); });
    }
    if (by === 'menor-preco') a.sort(function (x, y) { return x.p.price - y.p.price; });
    else if (by === 'maior-preco') a.sort(function (x, y) { return y.p.price - x.p.price; });
    else if (by === 'nome') a.sort(function (x, y) { return x.title.localeCompare(y.title, 'pt'); });
    else a.sort(function (x, y) { return (y.available - x.available) || (x.i - y.i); });
    return a;
  }

  /* ---------- Estado na URL (links compartilháveis) ---------- */
  var KEYS = ['equip', 'cat', 'marca', 'modelo', 'q', 'ordem', 'ver', 'disponivel'];
  function readState() {
    var sp = new URLSearchParams(location.search), st = {};
    KEYS.forEach(function (k) { if (sp.get(k)) st[k] = sp.get(k); });
    return st;
  }
  // push = true cria entrada no histórico (ex.: abrir a página de um modelo → "voltar" do navegador retorna à galeria).
  // As versões ouvem 'popstate' e re-renderizam a partir de readState().
  function writeState(st, push) {
    var sp = new URLSearchParams(location.search);
    KEYS.forEach(function (k) { if (st[k]) sp.set(k, st[k]); else sp.delete(k); });
    var qs = sp.toString();
    var url = location.pathname + (qs ? '?' + qs : '') + location.hash;
    if (push) history.pushState(null, '', url); else history.replaceState(null, '', url);
  }

  /* ---------- Carrinho (minicart do tema) ---------- */
  function updateCount() {
    return fetch('/cart.json').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.innerHTML = el.classList.contains('cart-count-drawer') ? '(' + cart.item_count + ')'
          : (cart.item_count > 100 ? '~' : cart.item_count);
      });
      var tp = document.querySelector('header-total-price');
      if (tp && tp.updateTotal) tp.updateTotal(cart);
      var fs = document.querySelector('free-ship-progress-bar');
      if (fs && fs.init) fs.init(cart.items_subtotal_price);
    }).catch(function () {});
  }
  function addToCart(variantId, qty) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var sections = cart && cart.getSectionsToRender ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }], sections: sections, sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status || res.errors) throw new Error(res.description || res.message || 'Não foi possível adicionar.');
      updateCount();
      if (cart) {
        if (res.sections) {
          sections.forEach(function (id) {
            var el = document.getElementById(id);
            if (!el || !res.sections[id]) return;
            var doc = new DOMParser().parseFromString(res.sections[id], 'text/html');
            var inner = doc.querySelector('#' + id);
            if (inner) el.innerHTML = inner.innerHTML;
          });
        }
        if (typeof cart.cartAction === 'function') cart.cartAction();
        if (typeof cart.open === 'function') cart.open();
      } else {
        location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      document.dispatchEvent(new CustomEvent('pecas:added', { detail: { variantId: variantId, qty: qty || 1 } }));
      return res;
    });
  }
  // Botões: <button data-pc-add data-variant="123">  ou dentro de um [data-pc-card] com <select data-pc-variant>
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-pc-add]');
    if (!btn) return;
    ev.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    var card = btn.closest('[data-pc-card]');
    var sel = card && card.querySelector('[data-pc-variant]');
    var qtyEl = card && card.querySelector('[data-pc-qty]');
    var id = (sel && sel.value) || btn.getAttribute('data-variant');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
    var label = btn.innerHTML;
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    addToCart(id, qty).then(function () {
      btn.classList.remove('is-loading'); btn.classList.add('is-added');
      btn.innerHTML = PecasEngine.icon('check') + '<span>Adicionado</span>';
      setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = label; }, 2200);
    }).catch(function (err) {
      btn.classList.remove('is-loading');
      btn.innerHTML = '<span>' + esc(err.message) + '</span>';
      setTimeout(function () { btn.innerHTML = label; }, 2600);
    }).finally(function () { btn.removeAttribute('aria-busy'); });
  });

  /* ---------- Altura do header fixo do tema → --pc-header-h (para elementos sticky) ---------- */
  function headerOffset() {
    var h = document.querySelector('.section-header'), v = 0;
    if (h) {
      var pos = getComputedStyle(h).position;
      if (pos === 'sticky' || pos === 'fixed') v = Math.max(0, Math.round(h.getBoundingClientRect().bottom));
    }
    document.documentElement.style.setProperty('--pc-header-h', v + 'px');
  }
  var hoTick = false;
  function hoSchedule() {
    if (hoTick) return; hoTick = true;
    requestAnimationFrame(function () { hoTick = false; headerOffset(); });
  }
  var hoLate;
  window.addEventListener('scroll', function () {
    hoSchedule();
    // o header do tema anima ao aparecer/sumir: mede de novo quando a transição termina
    clearTimeout(hoLate); hoLate = setTimeout(headerOffset, 450);
  }, { passive: true });
  document.addEventListener('transitionend', function (e) {
    if (e.target && e.target.closest && e.target.closest('.section-header')) hoSchedule();
  }, true);
  window.addEventListener('resize', hoSchedule);
  if (document.readyState !== 'loading') headerOffset(); else document.addEventListener('DOMContentLoaded', headerOffset);

  /* ---------- WhatsApp ---------- */
  function whatsapp(text) {
    return 'https://api.whatsapp.com/send?phone=' + WA_PHONE + '&text=' +
      encodeURIComponent(text || 'Olá! Preciso de ajuda para encontrar uma peça de reposição.');
  }

  /* ---------- Ícones (traço 1.75, currentColor) ---------- */
  var P = {
    wheelchair: '<circle cx="10" cy="4" r="1.6"/><path d="M10 7v6h5l2.5 5"/><path d="M10 10h5"/><path d="M7.5 10.5a5.5 5.5 0 1 0 7.8 6.4"/>',
    motor: '<circle cx="7" cy="17" r="3"/><circle cx="17.5" cy="17.5" r="2.5"/><path d="M7 14V6h3v6h7l1 3"/><path d="M13 3l-2 4h3l-2 4"/>',
    bath: '<path d="M4 12h16v2a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5z"/><path d="M6 12V6a2 2 0 0 1 4 0"/><path d="M7 19l-1 2M17 19l1 2"/>',
    walker: '<path d="M7 4h10M8 4l-3 17M16 4l3 17M6.5 12h11"/><circle cx="5" cy="21" r=".5"/><circle cx="19" cy="21" r=".5"/>',
    lift: '<path d="M4 21h16M6 21V5h9l3 3"/><path d="M18 8v4"/><path d="M15 12h6l-1 4h-4z"/>',
    inhaler: '<rect x="6" y="9" width="12" height="11" rx="2"/><path d="M9 9V6h6v3M12 13v3M10.5 14.5h3"/>',
    cpap: '<path d="M6 10c0-3 2.7-5 6-5s6 2 6 5-2 7-6 7-6-4-6-7z"/><path d="M12 17v4M9 21h6"/>',
    bed: '<path d="M3 6v13M3 14h18v5M21 14v-2a3 3 0 0 0-3-3h-7v5"/><circle cx="7" cy="11" r="1.8"/>',
    stroller: '<path d="M4 5h3l2 9h9l2-6H8"/><circle cx="9" cy="19" r="1.8"/><circle cx="17" cy="19" r="1.8"/>',
    wheel: '<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="2"/><path d="M12 3.5v6.5M12 14v6.5M3.5 12H10M14 12h6.5"/>',
    tire: '<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="4.5"/><path d="M12 3.5v2M12 18.5v2M3.5 12h2M18.5 12h2M6 6l1.4 1.4M16.6 16.6 18 18M6 18l1.4-1.4M16.6 7.4 18 6"/>',
    brake: '<circle cx="12" cy="12" r="8.5"/><path d="M7.5 7.5a6.4 6.4 0 0 0 0 9M16.5 7.5a6.4 6.4 0 0 1 0 9"/><circle cx="12" cy="12" r="2"/>',
    foot: '<path d="M8 3v9l-2 5h11a2 2 0 0 0 0-4h-5l-1-10z"/><path d="M5 21h14"/>',
    seat: '<path d="M7 3h7a2 2 0 0 1 2 2v7H7z"/><path d="M5 12h14v3H5zM7 15v6M17 15v6"/>',
    battery: '<rect x="3" y="7" width="16" height="10" rx="2"/><path d="M21 10.5v3M9 9.5l-2 3h4l-2 3"/>',
    joystick: '<rect x="5" y="15" width="14" height="6" rx="2"/><path d="M12 15V9"/><circle cx="12" cy="6" r="3"/>',
    wrench: '<path d="M14.7 6.3a4 4 0 0 0-5.4 5.2L3.5 17.3l3.2 3.2 5.8-5.8a4 4 0 0 0 5.2-5.4l-2.6 2.6-2.4-.4-.4-2.4z"/>',
    kit: '<rect x="3" y="7" width="18" height="13" rx="2"/><path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M3 12h18"/>',
    box: '<path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5z"/><path d="M3 7.5 12 12l9-4.5M12 12v9"/>',
    search: '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>',
    check: '<path d="m5 12.5 4.5 4.5L19 7.5"/>',
    cart: '<path d="M3 4h2l2.4 11.2a2 2 0 0 0 2 1.8h7.9a2 2 0 0 0 2-1.6L21 8H6"/><circle cx="10" cy="20.5" r="1"/><circle cx="18" cy="20.5" r="1"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    close: '<path d="M6 6l12 12M18 6 6 18"/>',
    chevron: '<path d="m9 6 6 6-6 6"/>',
    down: '<path d="m6 9 6 6 6-6"/>',
    filter: '<path d="M4 6h16M7 12h10M10 18h4"/>',
    whatsapp: '<path d="M20 11.6A8.3 8.3 0 0 1 7.8 19L3.5 20.5 5 16.3A8.3 8.3 0 1 1 20 11.6z"/><path d="M9 8.5c0 3.5 3 6.5 6.5 6.5l1-1.6-2-1-1 .9a4 4 0 0 1-2.5-2.5l.9-1-1-2z"/>',
    truck: '<path d="M3 6h11v10H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
    shield: '<path d="M12 3 5 6v5c0 4.5 3 8.5 7 10 4-1.5 7-5.5 7-10V6z"/><path d="m9 12 2 2 4-4"/>',
    tag: '<path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="8" r="1.2"/>',
    camera: '<path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.5"/>',
    ruler: '<path d="M3 17 17 3l4 4L7 21z"/><path d="m7 13 2 2M10 10l2 2M13 7l2 2"/>',
    label: '<rect x="4" y="5" width="16" height="14" rx="2"/><path d="M8 10h8M8 14h5"/>',
    grid: '<rect x="4" y="4" width="7" height="7" rx="1.5"/><rect x="13" y="4" width="7" height="7" rx="1.5"/><rect x="4" y="13" width="7" height="7" rx="1.5"/><rect x="13" y="13" width="7" height="7" rx="1.5"/>',
    list: '<path d="M9 6h11M9 12h11M9 18h11"/><circle cx="4.5" cy="6" r="1"/><circle cx="4.5" cy="12" r="1"/><circle cx="4.5" cy="18" r="1"/>',
    arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
    spark: '<path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M6 18l2.5-2.5M15.5 8.5 18 6"/>'
  };
  function icon(name, cls) {
    return '<svg class="pc-ico ' + (cls || '') + '" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (P[name] || P.box) + '</svg>';
  }

  /* ---------- Card padrão (as versões podem sobrescrever o visual via CSS ou usar o próprio) ---------- */
  function priceHTML(p, opt) {
    opt = opt || {};
    // opt.reserve: mantém as linhas vazias (preço riscado / parcelas) para alinhar os cards de uma mesma linha do grid
    var R = opt.reserve;
    return '<div class="pc-price">' +
      (p.compare ? '<s class="pc-price__compare">' + money(p.compare) + '</s>'
        : (R ? '<s class="pc-price__compare is-empty" aria-hidden="true">&nbsp;</s>' : '')) +
      '<div class="pc-price__cash"><strong>' + money(p.pix) + '</strong> <small>à vista</small></div>' +
      (opt.short ? '<div class="pc-price__inst">ou ' + p.n + 'x de ' + money(p.inst) + '</div>'
        : '<div class="pc-price__credit">ou <b>' + money(p.price) + '</b></div>' +
          (p.n > 1 ? '<div class="pc-price__inst">em <b>' + p.n + 'x</b> de <b>' + money(p.inst) + '</b> sem juros</div>'
            : (R ? '<div class="pc-price__inst is-empty" aria-hidden="true">&nbsp;</div>' : ''))) +
      '</div>';
  }
  function compatHTML(it, max) {
    if (it.universal) return '<span class="pc-compat pc-compat--uni">' + icon('check') + 'Universal</span>';
    if (!it.models.length) return '';
    var list = it.models.slice(0, max || 3).join(' · ') + (it.models.length > (max || 3) ? ' +' + (it.models.length - (max || 3)) : '');
    return '<span class="pc-compat">' + icon('check') + 'Compatível: ' + esc(list) + '</span>';
  }
  function buyHTML(it, opt) {
    opt = opt || {};
    if (!it.available) {
      return '<a class="pc-btn pc-btn--ghost" href="' + whatsapp('Olá! A peça "' + it.title + '" está esgotada no site. Vocês têm previsão?') + '" target="_blank" rel="noopener">' + icon('whatsapp') + '<span>Avisar pelo WhatsApp</span></a>';
    }
    var sel = '';
    if (it.multi) {
      sel = '<select class="pc-select" data-pc-variant aria-label="Opção">' + it.variants.map(function (v) {
        return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ' (esgotado)') + '</option>';
      }).join('') + '</select>';
    }
    return sel + '<button type="button" class="pc-btn pc-btn--buy" data-pc-add data-variant="' + it.variant.id + '">' +
      icon('cart') + '<span>' + (opt.label || 'Adicionar') + '</span></button>';
  }
  function card(it, opt) {
    opt = opt || {};
    var badges = '';
    if (it.p.off) badges += '<span class="pc-badge pc-badge--off">-' + it.p.off + '%</span>';
    if (!it.available) badges += '<span class="pc-badge pc-badge--out">Esgotado</span>';
    if (it.side) badges += '<span class="pc-badge">Lado ' + it.side.toLowerCase() + '</span>';
    if (it.pack) badges += '<span class="pc-badge">' + it.pack + '</span>';
    return '<article class="pc-card ' + (opt.cls || '') + '" data-pc-card>' +
      '<a class="pc-card__media" href="' + it.url + '" tabindex="-1" aria-hidden="true">' +
        (it.image ? '<img src="' + img(it.image, opt.w || 480) + '" alt="" loading="lazy" width="480" height="480">' : icon(catIcon(it.cat))) +
        (badges ? '<div class="pc-card__badges">' + badges + '</div>' : '') +
      '</a>' +
      '<div class="pc-card__body">' +
        (it.brand ? '<span class="pc-card__brand">' + esc(it.brand) + '</span>' : '') +
        '<a class="pc-card__title" href="' + it.url + '">' + esc(it.title) + '</a>' +
        (compatHTML(it) || '<span class="pc-compat pc-compat--empty" aria-hidden="true"></span>') +
        priceHTML(it.p, Object.assign({ reserve: true }, opt)) +
        '<div class="pc-card__buy">' + buyHTML(it, opt) + '</div>' +
      '</div></article>';
  }
  function catIcon(k) { var c = CATS.filter(function (x) { return x.key === k; })[0]; return c ? c.icon : 'box'; }
  function equipIcon(k) { var e = EQUIPS.filter(function (x) { return x.key === k; })[0]; return e ? e.icon : 'box'; }
  function equipLabel(k) { var e = EQUIPS.filter(function (x) { return x.key === k; })[0]; return e ? e.label : ''; }
  function catLabel(k) { var c = CATS.filter(function (x) { return x.key === k; })[0]; return c ? c.label : ''; }

  window.PecasEngine = {
    load: load, model: model, partsFor: partsFor, filter: filter, sort: sort, facets: facets, tokens: tokens,
    readState: readState, writeState: writeState,
    addToCart: addToCart, whatsapp: whatsapp,
    card: card, priceHTML: priceHTML, compatHTML: compatHTML, buyHTML: buyHTML,
    icon: icon, catIcon: catIcon, equipIcon: equipIcon, equipLabel: equipLabel, catLabel: catLabel,
    money: money, img: img, esc: esc, norm: norm, modelKey: modelKey,
    EQUIPS: EQUIPS, CATS: CATS
  };
})();
